<div class="sidebar-inner">

  <!-- Logo -->
  <div class="sidebar-logo">
    <span class="logo-link">
      <img src="assets/saisystems-health-logo.png" alt="Saisystems" class="logo-img" />
    </span>
    @if (isSlimMode) {
      <button
        class="pin-btn"
        (click)="toggleAnchor()"
        pRipple
        [pTooltip]="isAnchored ? 'Unpin sidebar' : 'Pin sidebar'"
        tooltipPosition="right">
        <i class="pi" [class.pi-lock]="isAnchored" [class.pi-lock-open]="!isAnchored"></i>
      </button>
    }
  </div>

  <!-- Navigation -->
  <nav class="sidebar-nav">
    <ul>
      @for (section of menuSections; track section.label) {
        @if (!isSlimCollapsed) {
          <li class="nav-section-label">{{ section.label }}</li>
        }
        @for (item of section.items; track item.label) {
          <app-menu-item [item]="item" [depth]="0" />
        }
      }
    </ul>
  </nav>

  <!-- Footer: layout mode switcher -->
  @if (!isSlimCollapsed) {
    <div class="sidebar-footer">
      <span class="footer-heading">Layout</span>
      <div class="mode-btns">
        <button
          (click)="setMode('static')"
          [class.active]="layoutService.isStatic()"
          pRipple
          pTooltip="Static"
          tooltipPosition="top">
          <i class="pi pi-stop"></i>
        </button>
        <button
          (click)="setMode('overlay')"
          [class.active]="layoutService.isOverlay()"
          pRipple
          pTooltip="Overlay"
          tooltipPosition="top">
          <i class="pi pi-clone"></i>
        </button>
        <button
          (click)="setMode('slim')"
          [class.active]="layoutService.isSlim()"
          pRipple
          pTooltip="Slim"
          tooltipPosition="top">
          <i class="pi pi-bars"></i>
        </button>
      </div>
    </div>
  }

</div>
